export class MessageConstants {
  static common = {
    noData: 'Data not provided',
    userActivate: 'User activated successfully.',
    userDeactivated: 'User deactivated successfully.',
    noResultsFound: 'No results found',
    error: 'Please contact to administrator.',
    changePasswordMessage: 'Password changed successfully. Please login again.',
    errorNewPaaswordSameAsOldPassword: 'New password should not be same as old password.',
  };

  static login = {
    invalidCredentials: 'Incorrect username or password.',
    loginSuccess: 'User logged in successfully.',
    loginPermission:
      'Non-Admin Users are not allowed to Login. Please contact Administrator for more details.',
  };

  static forgotPassword = {
    passwordSent: 'Password has been sent to your registered Email Id.',
  };

  static changePassword = {
    errorPasswordMismatch: 'New password and confirm password did not match.',
    changePasswordSuccessMessage: 'Password changed successfully.',
    confirmPasswordLengthError: 'Confirm Password cannot be more than 50 digits/characters.',
    confirmPasswordRequiredError: 'Please enter Confirm Password.',
  };

  public static readonly user = {
    adduserSuccess: 'User added successfully, Please continue to activate user.',
    edituserSuccess: 'User edited successfully.',
    selectAuthenticationTypeError: 'Please select authentication type.',
  };

  public static readonly payments = {
    exportError: 'No payment record to export.',
    mailSentSuccess: 'Mail sent successfully.',
    noRecordFound: 'No transactions available to export.',
    unhandledError: 'Something went wrong. Please contact administrator.',
  };

  public static readonly payment = {
    copied: 'Transaction Id copied successfully.',
    refundInitiated: 'Refund has been successfully initiated.',
    voidInitiated: 'VOID has been successfully initiated.',
    voidEligibleErrorMsg: 'Void is not available on this transaction.',
    refundEligibleErrorMsg: 'Refund is not available on this transaction.',
    platformAccountErrorMsg: 'Platform account transaction, cannot be refunded.',
  };

  public static readonly webhook = {
    addWebhook: 'Webhook added successfully.',
    updateWebhook: 'Webhook updated successfully.',
    deleteWebhook: 'Webhook deleted successfully.',
    noWebHooks: 'No Webhooks associated with this merchant.',
  };

  public static readonly developer = {
    RetriggerFailed: 'Webhook Event Not Found.',
    RetriggerSuccess: 'Webhook retriggered successfully.',
  };

  public static readonly report = {
    subscribeSuccess: 'Report enabled successfully.',
    unsubscribeSuccess: 'Report disabled successfully.',
    reportDataAvailable: 'Reports generated successfully.',
    reportDataNotAvailable: 'No Reports available',
  };

  public static readonly rollAPI = {
    allyKeyCommentCannotBeEmpty: 'Ally Key Comment Cannot Be Empty.',
    apiKeyGenerated: 'API key generated successfully. Old key will expire in 24 hours.',
  };

  public static readonly notification = {
    emailsAdded: 'Emails is/are added successfully.',
    emailsUpdated: 'Emails is/are updated successfully.',
    emailsRemoved: 'Email is removed successfully.',
    subscribed: 'Notification subscribed successfully.',
    unsubscribed: 'Notification unsubscribed successfully.',
    paused: 'All notifications are paused successfully.',
    unpaused: 'All notifications are unpaused successfully.',
    revertNotification: 'Reverted to last saved successfully',
    resetToSystemDefault: 'Reset to system default template successfully',
    saveTemplate: 'Template saved successfully.',
    invalidTempVariable: 'Invalid or Non-existent template variable added, kindly revisit.',
  };
}
